<template>
  <a-drawer
    :title="$t('userCenter')"
    :visible="sVisible"
    width="444"
    placement="right"
    @close="onClose"
  >
    <div class="user-center">
      <UserInfo v-if="showPanel === 1" @changeShowPanel="changeShowPanel" />
      <Bind
        v-if="showPanel === 2"
        :panel-type="panelType"
        @changeShowPanel="changeShowPanel"
      />
    </div>
  </a-drawer>
</template>

<script>
import UserInfo from "./userInfo";
import Bind from "./bind";

export default {
  components: {
    UserInfo,
    Bind
  },
  props: {
    visible: {
      type: Boolean
    }
  },
  data() {
    return {
      showPanel: 1,
      panelType: "mobile",
      sVisible: this.visible
    };
  },
  watch: {
    visible(val) {
      this.showPanel = 1;
      this.sVisible = val;
    }
  },
  methods: {
    changeShowPanel({ showPanel, panelType }) {
      this.showPanel = showPanel;
      this.panelType = panelType;
    },
    onClose() {
      this.sVisible = false;
      this.$emit("close", this.sVisible);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";

.user-center {
  padding: 0;
  /deep/ .custom-class {
    margin: 0 !important;
    float: right;
    height: 100%;
    border-radius: 0;

    .iw-dialog__header {
      padding: 0;
    }
    .iw-dialog__body {
      padding: 52px 30px;
      height: 100%;
      color: #292b33;
    }
  }
}
</style>
